import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import FotoscapeLink from '../../../components/FotoscapeLink/FotoscapeLink.tsx';
import LegalDocument from '../LegalDocument/LegalDocument.tsx';

const DEFAULT_LANG = 'en';

const privacyFilesByPath = import.meta.glob(
  '../../legal/privacy-policy.*.md',
  {
    query: '?raw',
    import: 'default',
    eager: true,
  }
) as Record<string, string>;

const privacyByLang: Record<string, string> = Object.entries(
  privacyFilesByPath
).reduce<Record<string, string>>((acc, [path, content]) => {
  const match = path.match(/privacy-policy\.([a-z]+)\.md$/);
  if (match) {
    acc[match[1]] = content;
  }
  return acc;
}, {});

const resolveContent = (lang: string): string => {
  const short = (lang || DEFAULT_LANG).split('-')[0].toLowerCase();
  return privacyByLang[short] ?? privacyByLang[DEFAULT_LANG] ?? '';
};

const ManagePrivacy: React.FC = () => {
  const { i18n } = useTranslation();
  const content = useMemo(
    () => resolveContent(i18n.language),
    [i18n.language]
  );

  return (
    <LegalDocument
      content={content}
      footer={
        <>
          <FotoscapeLink to="/manage-privacy-delete-data-req">
            Delete My Data
          </FotoscapeLink>
          <FotoscapeLink to="/manage-privacy-give-data-req">
            Give Me My Data
          </FotoscapeLink>
        </>
      }
    />
  );
};

export default ManagePrivacy;
